module.exports = __webpack_public_path__ + "img/box6_icon1.8469360b.jpg";